<template>
  <div class="layout-wrap">
    <div class="layout-inner">
      <layout-header
        v-if="!isApp"
        ref="header"
        :show-search="showSearch"
        :searching="searching"
        :show-menu="showNav"
        @switch-toggle="navOpen = !navOpen"
        @search-toggle="showSearch = $event"
        @echat="echatService()"
      />
      <div class="layout-container" :class="darkMode ? 'dark' : 'light'">
        <transition v-if="!isMobile" name="fade">
          <div
            v-show="showSearch"
            class="search-gap"
            @click="showSearch = false"
          >
          </div>
        </transition>
        <layout-nav
          v-show="showNav"
          :opened="navOpen"
          :dark-mode="darkMode"
          @switch-toggle="navOpen = false"
          @echat="echatService()"
        />
        <main
          ref="main"
          id="page-main"
          class="page-main"
          :class="{
            'with-nav': !showNav || navOpen,
          }"
          :style="{
            minWidth: isMobile ? pageWidth : 0,
            overflowY: lockScroll ? 'hidden' : 'auto',
          }"
          @scroll="handleScroll"
        >
          <div class="main-top" :style="{ width: pageWidth }">
            <button v-if="showBack" class="page-back" @click="navigatorBack">返回</button>
          </div>
          <CouponCountdown></CouponCountdown>
          <keep-alive :max="6">
            <router-view
              v-if="$route.meta.keepAlive"
              class="page-wrap"
              :class="{ 'show-footer': showFooter }"
              :style="{ width: pageWidth }"
            />
          </keep-alive>
          <router-view
            v-if="!$route.meta.keepAlive"
            class="page-wrap"
            :class="{ 'show-footer': showFooter }"
            :style="{ width: pageWidth }"
          />
          <layout-footer
            v-show="showFooter"
            :dark-mode="darkMode"
            @echat="echatService()"
          />
          
        </main>
        <transition name="fade">
          <div
            v-show="showBackTop"
            class="btn-backtop"
            @click="scrollBackTop"
          >
            <fps-icon type="back-to-top" size="24" />
          </div>
        </transition>
        <div v-if="!isMobile && floatVisible" class="login-guide-float">
          <div class="close" @click="floatVisible = false">
            <fps-icon type="close" />
          </div>
          <p>現在註冊即可獲得</p>
          <h3>『{{ $util.newerDiscount }}元新人體驗券』<br/>新人折扣低至免費！</h3>
          <button @click="handleLogin()">立即註冊</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutHeader from './header'
import LayoutNav from './nav'
import LayoutFooter from './footer'
import notify from '@/utils/web-notification'
import CouponCountdown from './new-coupon'
export default {
  components: {
    LayoutHeader,
    LayoutNav,
    LayoutFooter,
    CouponCountdown
  },
  data() {
    const isMobile = document.querySelector('body').offsetWidth < 600
    return {
      isMobile,
      floatVisible: false,
      hideNav: false,
      navOpen: !isMobile,
      hideFooter: false,
      showBack: false,
      darkMode: false,
      scrollTop: 0,
      lockScroll: false,
      showSearch: false,
      searching: false,
      loginAppeared: false, // 自动出现过登录弹窗
      reachBottom: false, // 滚动触底（距离底部50px）
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    // app 內
    isApp() {
      return this.$route.query.isApp && this.isMobile
    },
    routeName() {
      return this.$route.name
    },
    isHomePage() {
      return this.$route.name === 'homepage'
    },
    // 默认显示nav，除非router配置
    showNav() {
      return !this.hideNav && !this.isApp
    },
    // 默认隐藏footer，除非未登录或者router配置
    showFooter() {
      return (this.isMobile || (this.hideNav && !this.hideFooter)) && !this.isApp
    },
    // 顯示回頂按鈕
    showBackTop() {
      return this.scrollTop > 1200
    },
    // 页面宽度（默认1100px）
    pageWidth() {
      const { needMedia, pageWidth } = this.$route.meta
      if ((this.isMobile && needMedia) || pageWidth === '100%') {
        // 需要做移动适配的页面
        return '100%'
      } else if (pageWidth) {
        // 自定义 main-width
        return typeof pageWidth === 'number' ? pageWidth + 'px' : pageWidth
      } else {
        // 默认1100px
        return '1100px'
      }
    },
  },
  watch: {
    routeName(val) {
      this.initLayout()
      this.lockScroll = false
      if (val !== 'homepage') {
        const $main = this.$refs.main
        if (!$main) return
        $main.scrollTo(0, 0)
      }
    },
    userInfo(val) {
      if (val) {
        // 登录后隐藏注册浮窗
        this.floatVisible = false
        // 申请入驻步骤相关
        this.getSettleRate()
      }
    },
  },
  created() {
    this.initLayout()
    this.$store.dispatch('app/getGamesList')
    this.floatVisible = !this.userInfo
  },
  methods: {
    initLayout() {
      const { meta } = this.$route
      if (!meta) return
      this.hideNav = meta.hideNav
      this.hideFooter = meta.hideFooter
      this.showBack = meta.showBack
      this.darkMode = meta.darkMode
    },
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target
      this.scrollTop = scrollTop
      if (!this.loginAppeared && this.$route.path !== '/' && this.$route.path !== '/recent-dynamic' && scrollTop > 1960) {
        this.loginAppeared = true
        this.$util.Login({ isHome: this.isHomePage })
      }
      this.reachBottom = scrollTop + clientHeight + 50 > scrollHeight
    },
    handleLogin() {
      this.$util.Login({ isHome: this.isHomePage })
    },
    navigatorBack() {
      this.$router.go(-1)
    },
    scrollBackTop() {
      const $main = this.$refs.main
      if (!$main) return
      const start = $main.scrollTop
      const toTop = start > 0
      let i = 0
      const easeInOut = (t, b, c, d) => {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b
        return -c / 2 * (--t * (t - 2) - 1) + b
      }
      const render = () => {
        const next = Math.floor(easeInOut(20 * i, start, toTop ? -start : 0 * 2, 500))
        if (toTop ? next <= 0 : next >= 0) {
          $main.scrollTo(0, 0)
          window.cancelAnimationFrame(render)
        } else {
          $main.scrollTo(0, next)
          window.requestAnimationFrame(render)
        }
        i++
      }
      window.requestAnimationFrame(render)
    },
    // 一洽客服功能
    echatService(echatTag) {
      if (this.userInfo) {
        this.handleEchat(echatTag)
      } else {
        this.$util.Login().then(() => {
          this.handleEchat(echatTag)
        })
      }
    },
    async handleEchat(param) {
      !this.echatParams && (this.echatParams = { lan: 'zh-TW' })
      this.echatParams.echatTag = param || 'web_site'
      if (!this.echatInited) {
        this.echatInited = true
        this.echatLoading = true
        await this.echatInit()
        const open = () => {
          if (window.ECHAT) {
            window.ECHAT.customMiniChat(this.echatParams)
            this.echatLoading = false
            clearInterval(loop)
          }
        }
        const loop = setInterval(open, 1000)
      } else {
        if (this.echatLoading) return
        window.ECHAT.customMiniChat(this.echatParams)
      }
    },
    echatInit() {
      return new Promise(resolve => {
        // eslint-disable-next-line
        var _echatServer=["e.echatsoft.com"];
        window._echat = window._echat || function() {
          (window._echat.q = window._echat.q || []).push(arguments)
        };
        window._echat.l = Date.now();
        window._echat('initParam', {
          companyId: 523189,
        })
        window._echat('on',{
          newMsg: (num)=> {
            if(num&&window.ECHAT.getMiniStatus() === 'close') {
              notify('您收到了一條客服消息，請點擊“聯繫客服”中查看')
              // .then(notification => {
              //   notification.onclick = () => {
              //   };
              // });
              this.echatService()
            } 
          },
          newEvent: function () {
              //一洽事件消息
          }
        })
        this.$http.get('/echat/encrypt').then(({ data }) => {
          this.echatParams.metaData = data;
          (function() {
            var echat = document.createElement('script');
            echat.type = 'text/javascript';
            echat.async = true;
            echat.id = 'echatmodulejs';
            echat.setAttribute('charset', 'UTF-8');
            echat.src = (document.location.protocol == 'https:' ? 'https://' : 'http://') + 'www.echatsoft.com/visitor/echat.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(echat, s);
          })();
          resolve()
        })
      })
    },
    getSettleRate() {
      if (this.userInfo && window.localStorage.getItem(this.userInfo.uuid + '_RATE') && !window.localStorage.getItem('HAS_SEND_RATE')) {
        window.localStorage.setItem('HAS_SEND_RATE', '1')
      }
    },
  }
}
</script>

<style lang="scss">
  .page-wrap {
    > h1 {
      position: relative;
      padding-top: 46px;
      line-height: 50px;
      color: $color-gray-1;
      font-size: 30px;
      font-weight: 600;
    }
    .user-center-h1 {
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      padding-top: 24px;
      padding-bottom: 32px;
    }
  }
</style>

<style lang="scss" scoped>
  $width-main: 1100px;
  .layout-wrap {
    width: 100%;
    height: 100vh;
    .layout-inner {
      @include flex(flex-start, stretch, column);
      height: 100vh;
    }
  }
  .layout-container {
    flex-grow: 1;
    @include flex(flex-start, stretch);
    position: relative;
    overflow: hidden;
    height: 100%;
    &.dark {
      background-color: $color-dark;
    }
    &.light {
      background-color: $color-light;
    }
    .page-main {
      flex-grow: 1;
      position: relative;
      z-index: 0;
      height: 100%;
      margin-left: -110px;
      transition: all 0.15s linear;
      @include hideScrollBar(0, 0);
      &.with-nav {
        margin-left: 0;
      }
      .main-top {
        margin: 0 auto;
      }
      .page-back {
        width: 132px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border: 1px solid $color-split;
        color: $color-gray-2;
        border-radius: 50px;
        background: #fff;
        margin: 24px 0 36px;
      }
      .page-wrap {
        margin: 0 auto;
        min-height: 100%;
        &.show-footer {
          min-height: calc(100% - 66px);
        }
      }
    }
    .search-gap {
      position: absolute;
      z-index: 1000;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #000000, $alpha: 0.79);
    }
    .guide-sign {
      position: fixed;
      z-index: 99;
      right: 0;
      top: 100px;
      width: 192px;
      height: 102px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .btn-backtop {
    @include flex;
    position: fixed;
    z-index: 99;
    right: 24px;
    bottom: 76px;
    width: 48px;
    height: 48px;
    border-radius: 100%;
    background-color: $color-split;
    color: $color-gray-2;
    font-size: 24px;
    cursor: pointer;
  }
  .login-guide-float {
    position: fixed;
    z-index: 100;
    right: 10px;
    bottom: 10px;
    width: 360px;
    height: auto;
    padding: 25px 26px;
    background-color: #fff;
    border-radius: 8px;
    text-align: left;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
    .close {
      position: absolute;
      right: 15px;
      top: 15px;
      color: #999;
      cursor: pointer;
      &:hover {
        color: $color-gray-1;
      }
    }
    p {
      color: $color-gray-1;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
    h3 {
      margin-top: 4px;
      text-indent: -13px;
      color: $color-gray-1;
      font-weight: 600;
      font-size: 25px;
      line-height: 38px;
    }
    button {
      margin-top: 22px;
      width: 100px;
      height: 36px;
      border-radius: 36px;
      font-size: 14px;
      font-weight: 500;
      @include button-yellow;
    }
  }

  @media screen and (max-width: 599px) {
    .layout-container {
      overflow-x: auto;
      .page-main {
        margin-left: 0;
        .page-wrap {
          overflow-x: hidden;
          &.show-footer {
            min-height: 100%;
          }
        }
        .btn-backtop {
          right: 16px;
          bottom: 60px;
        }
      }
      .guide-sign {
        display: none;
      }
    }
  }
</style>